<template>
  <div
    :class="[
      'input-group',
      {
        'input-icon': Boolean(iconName),
        'input-user': iconName === 'user',
        'input-password': iconName === 'password',
        'input-search': iconName === 'search',
        'input-required': Boolean(required),
      },
    ]"
  >
    <div v-if="Boolean(labelText)" class="input-label-wrapper">
      <label
        :class="[
          'input-label',
          {
            'input-label_required': Boolean(required),
          },
        ]"
        >{{ labelText }}</label
      >
      <img
        :id="`select-tooltip-icon${id}`"
        v-if="Boolean(tooltipValue)"
        class="input-info"
        src="../../files/select-info-icon.svg"
        alt="info-icon"
      />
      <main-tooltip
        isHtml
        :target="`select-tooltip-icon${id}`"
        v-if="Boolean(tooltipValue)"
        :tooltipValue="tooltipValue"
      />
    </div>

    <input
      @input="$emit('input', $event.target.value)"
      @keydown="$emit('keydown', $event)"
      @wheel="preventWheel"
      :value="inputValue"
      :placeholder="placeholder"
      :type="inputType"
      :class="[
        'input',
        {
          'input_with-icon': Boolean(iconName),
          'is-invalid': Boolean(errorMessage),
        },
      ]"
      :required="required"
      :id="id"
      :name="name"
      :disabled="disabled"
    />
    <span class="invalid-feedback" v-show="errorMessage">{{
      Array.isArray(errorMessage) ? errorMessage[0] : errorMessage
    }}</span>
  </div>
</template>

<script>
import MainTooltip from "../ui/MainTooltip.vue";

export default {
  components: { MainTooltip },
  props: {
    iconName: {
      type: String,
      require: false,
    },
    inputValue: {
      type: [String, Number],
      require: false,
    },
    placeholder: {
      type: String,
      require: false,
    },
    labelText: {
      type: String,
      require: false,
    },
    inputType: {
      type: String,
      require: false,
    },
    required: {
      type: Boolean,
      require: false,
    },
    id: {
      type: String,
      require: false,
    },
    name: {
      type: String,
      require: false,
    },
    errorMessage: {
      type: [String, Array],
      require: false,
    },
    tooltipValue: {
      type: String,
      require: false,
    },
    disabled: {
      type: Boolean,
      require: false,
    },
  },
  methods: {
    preventWheel(event) {
      if (this.inputType === "number") {
        event.preventDefault();
      } else {
        this.$emit("wheel", event);
      }
    },
  },
};
</script>

<style scoped>
.input-group {
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}
.input {
  padding: 8px;
  width: 100%;
  height: 36px;
  background: var(--white-color);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  transition: border 0.15s ease-out;
}

.input:focus,
.input:hover {
  border: 1px solid var(--primary-color);
}

.input::-webkit-input-placeholder {
  color: var(--grey-3-color);
}
.input::-moz-placeholder {
  color: var(--grey-3-color);
}
.input:-moz-placeholder {
  color: var(--grey-3-color);
}
.input:-ms-input-placeholder {
  color: var(--grey-3-color);
}
.is-invalid {
  border-color: var(--error-color);
}
.input-label {
  position: relative;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: var(--black-color);
  margin-bottom: 0;
}
.input_with-icon {
  padding-left: 32px;
}
.input-icon::before {
  display: block;
  position: absolute;
  content: "";
  width: 16px;
  height: 16px;

  background-size: contain;
  left: 8px;
  top: 28px;
}

.input-user::before {
  background-image: url("../../files/assets/icon/user-icon.svg");
}

.input-password::before {
  background-image: url("../../files/assets/icon/lock-icon.svg");
}
.input-search::before {
  background-image: url("../../files/assets/icon/search-icon.svg");
}
.input-invalid {
  width: max-content;
  max-width: 100%;
  text-align: center;
  margin: 0 auto 4px;
  color: var(--error-color);
}
.input-label_required::after {
  content: " *";
  color: var(--error-color);
}
.input-label-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 4px;
}

.input-info {
  width: 16px;
  height: 16px;
  margin-left: 4px;
  color: var(--grey-icon-color);
}
</style>
